import { render, staticRenderFns } from "./EnConstruction.vue?vue&type=template&id=b90c2058&"
import script from "./EnConstruction.vue?vue&type=script&lang=js&"
export * from "./EnConstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b90c2058')) {
      api.createRecord('b90c2058', component.options)
    } else {
      api.reload('b90c2058', component.options)
    }
    module.hot.accept("./EnConstruction.vue?vue&type=template&id=b90c2058&", function () {
      api.rerender('b90c2058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnConstruction.vue"
export default component.exports